export const activeProfile = user => user?.emulation?.length ? user.emulation[user.emulation.length - 1] : user;
export const panelPermissions = user => activeProfile(user)?.permission || [];
export const hasPanelPermission = (user, permission) => panelPermissions(user).includes(permission);
export const canOpenPanelPath = (user, pathname) => hasPanelPermission(user, (pathname || '').split('/')[1]);

// Menu order and the permission array come from the existing navigation/role configuration.
export const homePath = (user, links) => {
    if (hasPanelPermission(user, 'dashboard')) return '/dashboard';
    return panelPermissions(user)
        .map(permission => links[permission]?.parent?.to)
        .find(path => typeof path === 'string' && path.startsWith('/') && canOpenPanelPath(user, path)) || null;
};
